var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    { ref: "validation", staticClass: "analise", attrs: { tag: "div" } },
    [
      _vm.despacho !== null
        ? _c(
            "div",
            { staticClass: "analise" },
            [
              _vm.despacho.processo !== null
                ? _c(
                    "app-analise-header",
                    {
                      attrs: {
                        "id-processo": _vm.despacho.processo.id,
                        "numero-processo": _vm.despacho.processo.numeroProcesso,
                        statusProcesso: _vm.despacho.processo.status,
                        "titulo-analise": "Emissão do extrato de sentença",
                        tipo:
                          typeof _vm.despacho.processo.tipo === "object"
                            ? _vm.despacho.processo.tipo.codigo
                            : _vm.despacho.processo.tipo,
                        numeroProtocolo: _vm.despacho.processo.numeroProtocolo,
                        "show-separate": true,
                        "show-messages": true,
                        opcoesHeader: true,
                        btnSolicitarInformacao: true,
                        idDespacho: _vm.despacho.id
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "separate" },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "card-collapse",
                              attrs: { shadow: "hover" }
                            },
                            [
                              _c("app-despachos", {
                                attrs: {
                                  idProcesso: _vm.idProcesso,
                                  data: _vm.dadosCadastro
                                },
                                on: { getDownload: _vm.getDownload }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "template",
                        { slot: "analise" },
                        [
                          _c(
                            "el-steps",
                            {
                              staticClass: "extra-margin-top-bottom",
                              attrs: {
                                active: _vm.active,
                                "finish-status": "success",
                                simple: "simple"
                              }
                            },
                            [
                              _c("el-step", {
                                attrs: { title: "Informar dados" }
                              }),
                              _c("el-step", {
                                attrs: { title: "Confirmar dados" }
                              })
                            ],
                            1
                          ),
                          _vm.active === 0
                            ? _c(
                                "div",
                                [
                                  _vm.despacho
                                    ? _c("app-emissao-extrato-sentenca", {
                                        ref: "formulario",
                                        attrs: { despacho: _vm.despacho }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            : _vm.active === 1
                            ? _c(
                                "div",
                                [
                                  _vm.bytes
                                    ? _c("app-pdf-viewer", {
                                        attrs: { bytes: _vm.bytes }
                                      })
                                    : _vm._e(),
                                  _c(
                                    "validation-observer",
                                    {
                                      ref: "validationTitulo",
                                      staticClass: "flex-around",
                                      attrs: { tag: "div" }
                                    },
                                    [
                                      _c("app-radios-tramitacao", {
                                        attrs: {
                                          radios: _vm.acoesRadio,
                                          isDecisao: false,
                                          radioInicial: _vm.despacho.acao
                                        },
                                        on: { changeRadio: _vm.changeRadio }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("app-buttons-cadastro", {
                            attrs: {
                              isPrimeiroPasso: _vm.active === 0,
                              isUltimoPasso: _vm.active === 1,
                              showButtonSalvar: [0].includes(_vm.active),
                              showButtonDownload: [1].includes(_vm.active),
                              showButtonCancelar: [0].includes(_vm.active),
                              showButtonFinalizar: [1].includes(_vm.active),
                              showButtonProximo: [0].includes(_vm.active)
                            },
                            on: {
                              proximo: _vm.proximo,
                              salvar: _vm.salvarExtratoSentenca,
                              voltar: _vm.voltar,
                              finalizar: _vm.finalizar,
                              download: _vm.downloadPdf,
                              cancelar: _vm.cancelar
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30cbe1a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30cbe1a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/EmissaoExtratoSentenca.vue
// module id = null
// module chunks = 